import type { Components, Theme } from '@mui/material/styles';

export const MuiTable: Components<Theme>['MuiTable'] = {
	styleOverrides: {
		root: {
			width: '100%',
			borderCollapse: 'separate',
			borderSpacing: 0,
			fontSize: 'var(--fs-body)',
		},
	},
};
